export enum InputType {
	text,
	textarea,
	url,
	number,
	password,
	email,
	select,
	multiselect,
	image,
	code,
	file,
	tel,
	radioGroup,
}
